import {AuthManager, getUrlEndpointPrivate} from '@cuatroochenta/co-admin-react-library';

export type RowErrorPayload = {line: number, column: string, message: string};

export type ImportPayload = {
    success?: boolean,
    error?: string | string[],
    errors?: RowErrorPayload[],
    data?: any,
};

const authorizedFetch = async (
    {path, method, headers = {}, body}: {path: string, method: string, headers?: Record<string, string>, body?: BodyInit},
): Promise<Response> => {
    const response = await fetch(getUrlEndpointPrivate(path), {
        method,
        headers: {...headers, Authorization: `Bearer ${AuthManager.getAuthToken()}`},
        body,
        mode: 'cors',
    });
    if (response.status === 401) {
        AuthManager.logout();
    }

    return response;
};

export const postJson = async ({path, body}: {path: string, body: object}): Promise<ImportPayload> => {
    const response = await authorizedFetch({
        path,
        method: 'POST',
        headers: {Accept: 'application/json', 'Content-Type': 'application/json'},
        body: JSON.stringify(body),
    });

    return response.json();
};

export const postFile = async ({path, file}: {path: string, file: File}): Promise<ImportPayload> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await authorizedFetch({path, method: 'POST', headers: {Accept: 'application/json'}, body: formData});

    return response.json();
};

export const downloadFile = async ({path, fileName}: {path: string, fileName: string}): Promise<ImportPayload | null> => {
    const response = await authorizedFetch({path, method: 'GET'});
    if ((response.headers.get('Content-Type') ?? '').includes('application/json')) {
        return response.json();
    }
    if (!response.ok) {
        throw new Error(`Template download failed with status ${response.status}`);
    }

    const url = URL.createObjectURL(await response.blob());
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
    setTimeout(() => URL.revokeObjectURL(url), 0);

    return null;
};

export const errorText = (payload: ImportPayload): string => (
    Array.isArray(payload.error) ? payload.error.join('\n') : (payload.error ?? '')
);
